import { EnvironmentTag } from '@zektec/environment-tag';
import { translate } from './i18n/messages';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { initSentry, SentryErrorBoundary } from './observability/sentry';
import '@zektec/ui/styles.css';
import './styles.css';

initSentry();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Missing root element.');
}

createRoot(rootElement).render(
  <StrictMode>
    <EnvironmentTag
      sources={{ mode: import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE }}
      version={import.meta.env.VITE_APP_VERSION}
    />
    <SentryErrorBoundary fallback={<div role="alert">{translate('billing.error.unexpected')}</div>}>
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
);
